<script>
	import {pop,push} from "svelte-spa-router";
	import {beforeUpdate} from "svelte";
	import {documentos} from "../controladores/store.js";
	import moment from "moment";
	let opcion = 0;
	let elegido ="text-xl font-bold mx-auto cursor-pointer w-full flex items-center justify-center border-b-2 border-pink-300";
	let normal ="text-xl font-bold mx-auto cursor-pointer w-full flex items-center justify-center";
	export let params;
	let mascota;
	let owner;
	let historias = [];
	let vacunas = [];
	let edad = "";
	let fecha;
	beforeUpdate(()=>{
		mascota = $documentos.filter((el)=>el.documento == params.documento)[0];
		/*fecha = moment(`${mascota.ano}${(mascota.mes-1<10? `0`${mascota.mes - 1}: `${mascota.mes - 1}`)}${(mascota.dia<10? `0${mascota.dia}`: `${mascota.dia}`)}`,"YYYYMMDD");
		*/owner = $documentos.filter((el)=>el.documento === mascota.dueno)[0];
		/*/calcular edad
		edad = fecha.fromNow();*/
		let nac  = moment(mascota.nacimiento);
		let ahora = moment();
		edad = `${ahora.diff(nac,"month")} meses`;
		//cargar vacunas
		vacunas = $documentos.filter((el)=>{
			return (el.tipo == "vacuna" && el.mascota == mascota.documento);
		})
		//cargar historias
		historias = $documentos.filter((el)=>{
			return (el.tipo == "historia" && el.mascota == mascota.documento);
		})
	})
	function historial(){
		opcion = 0;
	}
	function vacuna(){
		opcion = 1;
	}
	function volver(){
		pop();
	}
	function dueno(){
		push(`/cliente/${mascota.dueno}`);
	}
	function nhistoria(){
		push(`/mascota/${mascota.documento}/historia`);
	}
	function nvacuna(){
		push(`/mascota/${mascota.documento}/vacuna`);
	}
</script>
<div class="w-screen h-full min-h-screen max-w-full flex flex-col items-center justify-start bg-purple-300">
	<button on:click={volver} class="p-2 m-4 flex self-start items-center justify-center bg-purple-500 cursor-pointer text-white rounded">Volver</button>
	<button on:click={nhistoria} class="p-2 m-4 flex items-center justify-center bg-purple-500 cursor-pointer text-white rounded"><i class="ri-add-line" /> Historia</button>
	<button on:click={nvacuna} class="p-2 m-4 flex items-center justify-center bg-purple-500 cursor-pointer text-white rounded"><i class="ri-add-line" /> Vacuna</button>
	
	<div class="w-3/4 flex flex-col items-center justify-center h-auto m-4 p-4 bg-gray-100 rounded shadow">
		<h1 class="text-xl font-bold m-auto w-full text-center">{mascota.nombre}</h1>
		<div class="flex items-center justify-between w-3/4 my-4">
			<div class="flex flex-col items-start">
				<span class="text-sm font-bold">Documento</span>
				{mascota.documento}
			</div>
			<div on:click={dueno} class="flex flex-col items-start cursor-pointer">
				<span class="text-sm font-bold">Dueño</span>
				{owner.nombre}
			</div>
		</div>
		<div class="flex items-center justify-between w-3/4 my-4">
			<div class="flex flex-col items-start">
				<span class="text-sm font-bold">Especie</span>
				{mascota.especie}
			</div>
			<div class="flex flex-col items-start">
				<span class="text-sm font-bold">Raza</span>
				{mascota.raza}
			</div>
		</div>
		<div class="flex items-center justify-between w-3/4 my-4">
			<div class="flex flex-col items-start">
				<span class="text-sm font-bold">Tamaño</span>
				{mascota.tamano}
			</div>
			<div class="flex flex-col items-start">
				<span class="text-sm font-bold">Edad</span>
				{edad}
			</div>
		</div>
		<div class="flex items-center justify-between w-3/4 my-4">
			<div class="flex flex-col items-start w-full">
				<span class="text-sm font-bold">Detalle</span>
				{mascota.detalle}
			</div>
		</div>
	</div>
	<div class="flex flex-col items-center justify-start bg-gray-100 rounded m-4 p-4 w-3/4 h-auto shadow">
		<div class="flex items-center justify-center w-full">
			<div on:click={historial} class={(opcion == 0? elegido : normal)}>
				Historial
			</div>
			<div on:click={vacuna} class={(opcion == 1? elegido : normal)}>
				Vacunas
			</div>
		</div>
		<div class="flex flex-col items-center justify-start w-full">
			{#if opcion == 0}
				{#each historias as h}
				<div class="w-full flex flex-col items-center  p-2 border-b-2">
					<div class="flex flex-col items-center justify-between m-2 w-full">
						<div class="flex flex-col items-center justify-center m-2">
							<span class="text-sm font-bold">Fecha</span>
							{h.dia}/{h.mes}/{h.ano}
						</div>
						<div class="flex w-full items-center">
							<div class="flex flex-col items-center justify-center m-2">
								<span class="text-sm font-bold">Peso</span>
								{h.peso}Kg
							</div>
							<div class="flex flex-col items-center justify-center m-2">
								<span class="text-sm font-bold">Temperatura</span>
								{h.temperatura}C°
							</div>
							<div class="flex flex-col items-center justify-center m-2">
								<span class="text-sm font-bold">F.Cardiaca</span>
								{h.pulsaciones}
							</div>
						</div>
						<div class="flex flex-col items-center justify-center m-2 w-full">
							<span class="text-sm font-bold">Detalle</span>
							{h.detalle}
						</div>
					</div>
				</div>
			{/each}
			{:else}
			{#each vacunas as v}
				<div class="flex items-center justify-start p-2 border-b-2 w-full sm:flex-col">
					<div class="flex flex-col items-center justify-between">
						<span class="text-sm font-bold">Fecha</span>
						{v.dia}/{v.mes}/{v.ano}
					</div>
					<div class="flex flex-col items-center justify-center w-full m-auto">
						<span class="text-sm font-bold">Vacuna</span>
						{v.vacuna}
					</div>
					<div class="flex flex-col items-center justify-center">
						<span class="text-sm font-bold">Veterinario</span>
						{v.veterinario}
					</div>
				</div>
			{/each}
			{/if}
		</div>
	</div>
</div>
